import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.currentUser
  }
}

class RequiresAuth extends Component {
  componentWillMount () {
    this.authenticateUserOrRedirect(this.props)
  }

  componentWillReceiveProps (nextProps) {
    this.authenticateUserOrRedirect(nextProps)
  }

  authenticateUserOrRedirect (props) {
    if (props.currentUser && props.currentUser.id) return
    this.redirectToLogin()
  }

  redirectToLogin () {
    this.props.router.push('/login')
  }

  render () {
    if (this.props.currentUser && this.props.currentUser.id) {
      return this.props.children
    } else {
      return null
    }
  }
}

RequiresAuth.propTypes = {
  children: PropTypes.object.isRequired
}

export default connect(mapStateToProps)(withRouter(RequiresAuth))



// WEBPACK FOOTER //
// ./src/containers/requires-auth.js